var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragTrigger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#888;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-221 -181)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,0H23a0,0,0,0,1,0,0V16a0,0,0,0,1,0,0H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    transform: "translate(221 181)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.572 -21.142)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 12,
    transform: "translate(112.427 212.142)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 12,
    transform: "translate(112.427 208.142)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragTrigger);
export default __webpack_public_path__ + "static/media/drag-trigger.7cd94528506318f2acfb08480433fe81.svg";
export { ForwardRef as ReactComponent };